import { parse } from "@evidenceb/athena-common/modules/HTMLParser";
import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { useRouteMatch } from "react-router-dom";
import ResourceCard from "../../../../../design-system-components/ResourceCard/ResourceCard";
import PageWrapper from "../../../../../components/PageWrapper/PageWrapper";
import PageHeader from "../../../../../components/PageHeader/PageHeader";
import useTeacherDuo from "../useTeacherDuo";
import { pageTitles } from "../../../../../utils/messages";
import { useData } from "../../../../../hooks/useData";

import "./DuoWorkModeList.scss";

const DuoWorkModeList = () => {
    const data = useData();
    const { url } = useRouteMatch();
    const intl = useIntl();
    const { numberOfPlayableDuosInModule } = useTeacherDuo();

    return (
        <PageWrapper>
            <PageHeader
                title={{
                    content: intl.formatMessage(pageTitles.studentDuosList),
                }}
            />
            <div className="duo-wm-list">
                {/*
                 * Quand le concept de domaine d'études sera implémenté:
                 * - Filter par domaine d'etudes dans le premier map, puis par module d'un domaine d'etude dans le deuxième map
                 * - Décommenter le h3 pour ajouter le titre du module d'étude
                 */}
                {/* {data.modules.map(module => ( */}
                <div className="duo-wm-list__resource-container">
                    {/* <h3 className="duo-wm-list__resource-title">{parse(module.description.$html)}</h3> */}
                    <ul className="duo-wm-list__resource-list">
                        {data.modules.map((module) => {
                            return (
                                <li
                                    key={module.id}
                                    className="duo-wm-list__resource-card"
                                >
                                    <ResourceCard
                                        icon={{
                                            path: "icon_mode_duo",
                                            color: "var(--ressources-fill-duo)",
                                            size: "medium",
                                        }}
                                        colors={{
                                            borderHover: "var(--block-header)",
                                        }}
                                        name={{
                                            as: "h4",
                                            content: parse(
                                                module.title.short ??
                                                    module.title.long
                                            ),
                                        }}
                                        description={intl.formatMessage(
                                            messages.duo,
                                            {
                                                numDuo: numberOfPlayableDuosInModule(
                                                    module.id
                                                ),
                                            }
                                        )}
                                        clickAction={{
                                            to: `${url}/${module.id}`,
                                            altTxt: intl.formatMessage(
                                                messages.seeListOfDuos,
                                                {
                                                    moduleName:
                                                        module.title.short ??
                                                        module.title.long,
                                                }
                                            ),
                                            type: "internalRedirection",
                                        }}
                                    />
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {/* ))} */}
            </div>
        </PageWrapper>
    );
};

const messages = defineMessages({
    duo: {
        id: "duo-mode-duo-plural",
        defaultMessage: `{numDuo, plural,
                            =0 {No duo yet}
                            =1 {1 duo}
                            other {# duos}
                        }`,
    },
    seeListOfDuos: {
        id: "workmodes-duo-seeListOfDuosInModule",
        defaultMessage: "See all duos in module {moduleName}",
    },
});

export default DuoWorkModeList;
